import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from 'src/app/utils/models/page-header';
import { Menu } from '../../models/menu';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, ConfigService } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { MenuService } from '../../services/menu.service';
import { ModuleService } from '../../services/module.service';
import { Module } from '../../models/module';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerEntity: PageHeader;
  entity: Menu = new Menu();
  editingEntity: Menu = new Menu();
  module: Array<Module>;
  menuColumns: any[];
  listView: boolean = true;
  formCaption: string = '';
  selectedParentMenu: any;
  selectedMenu: Menu = new Menu();
  selectedmodule: any;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  menu: any;
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  constructor(
    private _moduleService: ModuleService,
    private _menuService: MenuService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private configService: ConfigService,
  ) {
    {
      this.headerEntity = this.initPageHeader();
      this.menuColumns = [
        { field: "SlNo", title: 'SL No', filter: true, sortable: true },
        { field: "Menu_Name", title: 'Name', filter: true, sortable: true },
        { field: "Menu_Parent_Name", title: 'Parent Menu', filter: true, sortable: true },
        { field: "Module_Name", title: 'Module Name', filter: true, sortable: true },
        { field: "Menu_URL", title: 'URL', filter: true, sortable: true },
      ];
      this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
      this.pageSizes = this.configService.getConfigValue('pageSizes');
      this.menu = [];
      this.getAllMenus();
      this.module = [];
      this.getAllModules('');
      this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    }
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._menuService.getAllMenus('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1)).subscribe((menu: Array<Menu>) => {
      this.menu = {
        data: menu,
        total: menu[0] ? menu[0].TotalCount : 0
      }
    });
  }
  getAllModules(filter: string) {
    this._moduleService.getAllModules(filter, this.defaultRowsCount, 1).subscribe((module: Array<Module>) => {
      this.module = module;
    });
  }
  getAllMenus() {
    this._menuService.getAllMenus('', Number(this.defaultPageSize), 1).subscribe((menu: Array<Menu>) => {
      this.menu = {
        data: menu,
        total: menu[0] ? menu[0].TotalCount : 0
      }
    });
  }

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._menuService.deleteMenu(this.selectedMenu.Menu_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearMenu();
            this.getAllMenus();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerEntity = new PageHeader();
    headerEntity.PageCaption = "MENU";
    headerEntity.IconClass = "bi bi-menu-button-wide";
    return headerEntity;
  }
  deleteMenu(event: any) {
    if (event.seletedRows[0]) {
      this.selectedMenu.Menu_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Menu",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  addMenu(event: any) {
    this.listView = false;
    this.getAllMenus();
    this.getAllModules('');
    this.clearMenu();
    this.formCaption = "Add Menu";
  }
  editEntity(event: any): void {
    if (event.seletedRows[0]) {
      // let editEntity = this.menu.find(x => x.Menu_Id === event.seletedRows[0]);
      this._menuService.viewMenu(event.seletedRows[0]).subscribe((menu: Array<Menu>) => {
        let editEntity = menu[0] ? menu[0] : new Menu();
        if (editEntity) {
          this.editingEntity = editEntity;
          this.entity = { ...this.editingEntity };
          this.selectedParentMenu = { Menu_Name: editEntity.Menu_Name, Menu_Id: editEntity.Menu_Id };
          this.selectedmodule = { Module_Name: editEntity.Module_Name, Module_Id: editEntity.Module_Id };
          this.listView = false;
          this.formCaption = "Edit Menu";
          this.getAllMenus();
          this.getAllModules('');

        }
      });
    }
  }
  save(event: any): void {
    this.saveDisabled = true;

    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._menuService.checkDuplication(this.entity.Menu_Name, this.entity.Menu_Id).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Menu already exists');
          this.saveDisabled = false;
        }
        else {

          this._menuService.saveMenu(this.entity).subscribe(() => {
            if (this.entity.Menu_Id == "") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearMenu();
            this.getAllMenus();
            this.getAllModules('');
          })
        }
      });
    }
  }

  gotoBack(): void {
    this.listView = true;
  }
  refreshMenu(event: any): void {
    this.menu = [];
    this.getAllMenus();
  }
  clearMenu(): void {
    this.entity = new Menu();
    this.selectedParentMenu = {};
    this.selectedmodule = {};
    this.saveDisabled = false;
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}



